import { Title, MSection } from "components/misc";
import { ROUTES } from "const";
import { Icon } from "design-react-kit";
import React, { Component } from "react";
import { NavLink, withRouter } from 'react-router-dom';


class CourseTutorMNE extends Component {

    state = {
        rCode: ''
    };

    goBack() {
        window.history.back();
    }

    render() {
        const { rCode } = this.props.match.params;

        return (
            <>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title >Assistenza Didattica</Title>
                <MSection className="mt-2">
                    <p>Il personale dedicato all’assistenza didattica è disponibile dal lunedì al venerdì, dalle 09:00 alle 13:00 e dalle 14:30 alle 18:00, al recapito telefonico <a href="tel:+39 3934483737" >3934483737</a> e all’indirizzo email <a href="mailto:english@formazionedocenti.it">english@formazionedocenti.it</a>.</p>
                </MSection>
            </>);
    }
}

export default withRouter(CourseTutorMNE);